import { jsx as _jsx } from "react/jsx-runtime";
import { fetchSimilarListings } from "@/api/fetchSimilarListings";
import { useSimilarListings } from "@/components/SimilarListings/useSimilarListings";
import { SIMILAR_LISTING_PATH } from "@/constants/api";
import { useClassifiedId } from "@/contexts/classified";
import { useBrandUrl, useIsIntersecting } from "@/hooks";
import { useEffect } from "react";
import { useSellerLeadLink } from "../Sections/SellerLeadTeaser";
import { SimilarListings } from "./SimilarListings";
export const SimilarListingCSR = () => {
    const { similarListings, similarRecords, isDisplayed, isFetched, setSimilarListingsData, } = useSimilarListings();
    const { isIntersecting } = useIsIntersecting({
        elementId: "price",
        triggerOnce: true,
        rootMargin: "50px",
    });
    const classifiedId = useClassifiedId();
    const similarListingsUrl = useBrandUrl({
        // @ts-ignore
        endpoint: SIMILAR_LISTING_PATH(classifiedId),
    });
    const { funnel: funnelUrl } = useSellerLeadLink();
    useEffect(() => {
        if (!isFetched && !isDisplayed && isIntersecting && classifiedId) {
            fetchSimilarListings(similarListingsUrl).then((data) => {
                setSimilarListingsData(data);
            });
        }
    }, [
        isFetched,
        isDisplayed,
        isIntersecting,
        similarListingsUrl,
        setSimilarListingsData,
        classifiedId,
    ]);
    return (_jsx(SimilarListings, { similarListings: similarListings, similarRecords: similarRecords, isDisplayed: isDisplayed, funnelUrl: funnelUrl || null }));
};
